
export default
    name: "gender-icon"
    props:
        gender: [String, Number]
        required: true
        validator: (value) ->
            ['male', 'female', 'mixed', 'M', 'F', 'X', 1, 2, 3].indexOf(value) != -1

    methods:
        gender_icon: (gender) ->
            switch gender
                when 'male', 'M', 1 then 'fa-mars'
                when 'female', 'F', 2 then 'fa-venus'
                when 'mixed', 'X',  3  then 'fa-venus-mars'
                else 'fa-genderless'


